//#region src/printer_type.ts
var PrinterType = /* @__PURE__ */ function(PrinterType) {
	PrinterType[PrinterType["NoPrinter"] = 0] = "NoPrinter";
	PrinterType[PrinterType["TM_M30"] = 1] = "TM_M30";
	PrinterType[PrinterType["TM_T88V"] = 2] = "TM_T88V";
	PrinterType[PrinterType["TM_U220"] = 3] = "TM_U220";
	PrinterType[PrinterType["TM_T88VI_IHub"] = 4] = "TM_T88VI_IHub";
	PrinterType[PrinterType["TM_U220I"] = 5] = "TM_U220I";
	PrinterType[PrinterType["Snbc_BtpS80"] = 6] = "Snbc_BtpS80";
	PrinterType[PrinterType["RP_F10"] = 7] = "RP_F10";
	PrinterType[PrinterType["SamsungBuiltIn"] = 10001] = "SamsungBuiltIn";
	PrinterType[PrinterType["LgBuiltIn"] = 10002] = "LgBuiltIn";
	PrinterType[PrinterType["AcrelecBuiltIn"] = 10003] = "AcrelecBuiltIn";
	PrinterType[PrinterType["HpBuiltIn"] = 10004] = "HpBuiltIn";
	PrinterType[PrinterType["PosiflexBuiltIn"] = 10005] = "PosiflexBuiltIn";
	PrinterType[PrinterType["TouchDynamicBuiltInEpsonM30"] = 10006] = "TouchDynamicBuiltInEpsonM30";
	return PrinterType;
}(PrinterType || {});
//#endregion
export { PrinterType };

//# sourceMappingURL=printer_type.js.map